<template>

	<div ref="container" class="d-flex flex-column h-100 container container-patient-messages">
		<loading ref="loading"></loading>

		<full-image-dialog ref='fullImageDialog' :thread='thread' :in_image='full_image' />

        <document-download-dialog ref='documentDownloadDialog' :thread='thread' :in_document_download='document_download' />

		<!-- <b-modal ref="videoChatModal" title="Vido Call" size="lg">
			<gruveo></gruveo>
		</b-modal> -->
		<div ref="header" class="patient-banner d-flex">
			<div style="width:50px">
				<img src="img/egl/myaccount-standard2.svg" alt="">
			</div>
			
			<div class="w-100 border-bottom pb-2">
				<h1 class="page-title sr-only">{{$t('translations.creating_new_message_title')}}</h1>
				<p><strong v-text="getThreadUser()"></strong></p>
				<p><small>{{providerName}} {{providerStatus}}</small></p>
			</div>
		</div>

		<p class="mt-2" v-if='this.type == "create" && !isServiceAvailable()'>
			<span class="icon-appointment mt-4 mb-3">
                <svg x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><path id="Shape" 
                        d="M18,12c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S14.7,12,18,12z M18,13.5c-2.5,0-4.5,2-4.5,4.5
		s2,4.5,4.5,4.5s4.5-2,4.5-4.5S20.5,13.5,18,13.5z M15,0c0.5,0,0.9,0.4,1,0.9L16,1v1h2c1.6,0,2.9,1.2,3,2.8L21,5v4
		c0,0.5-0.4,0.9-0.9,1L20,10H3v9c0,0.5,0.4,0.9,0.9,1L4,20h6c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1L10,22H4c-1.6,0-2.9-1.2-3-2.8
		L1,19V5c0-1.6,1.2-2.9,2.8-3L4,2h2V1c0-0.6,0.4-1,1-1c0.5,0,0.9,0.4,1,0.9L8,1v1h6V1C14,0.4,14.4,0,15,0z M18,14.2
		c0.4,0,0.7,0.3,0.7,0.6l0,0.1v2.6l1.7,1.3c0.3,0.2,0.4,0.6,0.2,1L20.6,20c-0.2,0.3-0.6,0.4-1,0.2l-0.1-0.1l-2-1.5
		c-0.2-0.1-0.3-0.3-0.3-0.5l0-0.1v-3C17.2,14.6,17.6,14.2,18,14.2z M6,4H4C3.5,4,3.1,4.4,3,4.9L3,5v3h16V5c0-0.5-0.4-0.9-0.9-1L18,4
		h-2v1c0,0.5-0.4,0.9-0.9,1L15,6c-0.5,0-0.9-0.4-1-0.9L14,5V4H8v1c0,0.5-0.4,0.9-0.9,1L7,6C6.5,6,6.1,5.6,6,5.1L6,5V4z"/></g></svg>
            </span>
			<template v-if='$root.provider.network_service_status == 0'>
                {{autobrand('translations.network_is_currently_unavailable_for_online_requests')}}
            </template>
            <template v-else>
                <div>{{ serviceAvailabliltyMessage() }}</div>
                <div v-if='this.$root.encryptStorage'>{{autobrand('translations.session_saved_for_later')}}</div>
            </template>
		</p>
		
		<ul v-if='this.type == "edit" || isServiceAvailable()' ref="message-list-container" class="list list-message flex-grow-1">
			<template v-for="(item, index) in items.data">
				<li :key='item.id'
					:class='"list-message_item " + getMessageAuto(index) + " " + getMessageClass(item.user.id) + (item.internal ? " message-internal" : "")'>

					<h2 class="h6 d-flex flext-wrap justify-content-between">
                        <span>{{formatNameForItem(item)}}</span>
						<span class="time-stamp">{{formatDateTime(item.created_at)}}</span>
					</h2>

					<div :class='"list-message_item_body " + (item.internal ? "list-message-internal" : "")'>
						<p v-if='item.question' class='message-question-content' v-html='formatContent($t("qa."+item.question.content), true)'></p>
                        <div class="d-flex flex-wrap align-items-end" v-if='(item.message_image && item.message_image.length) || (item.attached_images && item.attached_images.length) || (item.message_document && item.message_document.length) || (item.attached_documents && item.attached_documents.length)'>
                            <template v-if='item.message_image && item.message_image.length'>
                                <img :key='image_index' :width='image.image.tn_width' :height='image.image.tn_height' v-on:click='showFullImageDialog(image.image_id, thread.archived)' class='thumbnail-image mr-2 border' v-for='(image, image_index) in item.message_image' :src="getImageSrc(image.image.id, true)">
                                <!-- <img :width='image.image.tn_width' :height='image.image.tn_height' v-on:click='showFullImageDialog(image.image_id, thread.archived)' class='mr-2 border' v-for='image in item.message_image' :src="image_data[image.image.id] ? image_data[image.image.id].tn_data : ''"> -->
                            </template>
                            <template v-else-if='item.attached_images && item.attached_images.length'>
                                <template v-for='(image, image_index) in item.attached_images'>
                                    <img v-if='image.tn_canvas.toDataURL' :key='image_index' class='thumbnail-image mr-2 border'  :src='item.attached_images[image_index].tn_canvas.toDataURL("image/jpeg")'>
                                </template>
                                <!-- <img :width='image.image.tn_width' :height='image.image.tn_height' v-on:click='showFullImageDialog(image.image_id, thread.archived)' class='mr-2 border' v-for='image in item.message_image' :src="image_data[image.image.id] ? image_data[image.image.id].tn_data : ''"> -->
                            </template>
                            <template v-if='item.message_document && item.message_document.length'>
                                <div :key='"document" + document_index' class="d-flex flex-column mr-2" v-for='(document, document_index) in item.message_document'>
                                    <a v-on:click='showDocumentDownloadDialog(document.document, thread.archived)'>
										<div class="p-1 bg-light document-upload__container">
                                        	<img class='mt-auto align-self-center' src='/img/icon-document.svg' width='50' height='50'>
                                        	<p class='align-self-center'>{{document.document ? document.document.name : document.file_name}}</p>
										</div>
                                    </a>
                                </div>
                            </template>
                            <template v-else-if='item.attached_documents && item.attached_documents.length'>
                                <div :key='"document" + document_index' class="d-flex flex-column mr-2" v-for='(document, document_index) in item.attached_documents'>
                                    <a v-on:click='showDocumentDownloadDialog(document.document, thread.archived)'>
										<div class="p-1 bg-light document-upload__container">
                                        	<img class='mt-auto align-self-center' src='/img/icon-document.svg' width='50' height='50'>
                                        	<p class='align-self-center'>{{document.document ? document.document.name : document.file_name}}</p>
										</div>
                                    </a>
                                </div>
                            </template>
                        </div>
                        <template v-if='index == edit_index'>
                            <!-- <textarea  :class='"new-message-patient p-1" + (item.internal ? " list-message-internal" : "")' v-model="item.message" type="textarea" v-text='item.message'></textarea> -->
                            <textarea  :class='"new-message-patient p-1" + (item.internal ? " list-message-internal" : "")' v-model="item.message" type="textarea"></textarea>
                            <div class="d-flex flex-wrap">
                                <button v-on:click="cancelEditMessage(index)" class="btn btn-sm btn-light ml-2">{{ $t('translations.cancel')}}</button>
                                <button v-on:click="saveMessage(index)" class="btn btn-sm btn-success ml-2">{{ $t('translations.save')}}</button>
                                <span class='chars-left ml-auto' aria-live="polite">{{editCharactersLeft}}</span>
                            </div>
                        </template>
                        <template v-else>
                            
                            <template v-if='item.video && thread'>
                                <p> {{ $t("translations.video_request") }} </p>
                                <template v-if='item.video.ended_at == null'>
                                    <gruveo v-if='!thread.closed_at' :video-room='item.video.room' :message-id='item.id'></gruveo>
                                </template>
                                <template v-else>
                                    <p v-text='"Call ended at " + formatDateTime(item.video.ended_at)'></p>
                                    <p v-text='"Call lasted for " + moment.utc(moment.duration(moment(item.video.ended_at).diff(item.video.started_at)).as("milliseconds")).format("HH:mm:ss")'></p>
                                </template>
                            </template>
                            <p v-else-if='!item.appointment || !item.appointment.start_at' v-html='formatMessageContent(item)'></p>

                            <message-appointment 
                                v-if='item.appointment' 
                                :show-book='thread && !thread.closed_at' 
                                v-bind:appointment.sync='item.appointment' 
                                v-on:edit_appointment='$router.push({path: "/booking/" + item.appointment.id})' />
                            <div class='mt-4 card card--form'
                                v-if='item.form_submission && item.form_submission.length'>
                                
                                <template v-if='item.form_submission[0].submitted_at'>
                                    <div class='mb-1'>Form submitted at {{ item.form_submission[0].submitted_at | formatDateTime }} by {{ formatNameWithProvider(item.form_submission[0].user, item.provider, item.thread, items.data) }} </div>
                                    <!-- <ul v-if='item.form_submission[0].content && JSON.parse(item.form_submission[0].content) && JSON.parse(item.form_submission[0].content).readable'>
                                        <li :key='item.name' v-for='item in JSON.parse(item.form_submission[0].content).readable'>
                                            {{item.plain}}
                                        </li>
                                    </ul> -->
                                </template>
                                <router-link :to="'/form-submission/' + item.form_submission[0].id + ($route.params['archive'] ? '/1' : '')" tag="button" class="btn btn-round btn-primary w-100"><template v-if='item.form_submission[0].submitted_at'>{{ $t('translations.view_form') }}</template><template v-else>{{ $t('translations.fill_in_form') }}</template> {{ getFormTitle(item.form_submission[0]) }}</router-link>
                            </div>
                            
                            <!-- <template item.user_id == $root.user.id'>
                                <button v-if='item.video == null' v-on:click="editMessage(index)" class="btn-edit">Edit</button>
                                <button v-on:click="deleteMessage(index)" class="btn-delete">Delete</button>
                            </template> -->
                        </template>
					</div>

				</li>
			</template>
		</ul>
		<!-- <div class='overflow-auto-fixme' v-if='this.type == "edit" || isServiceAvailable()' ref="footer" style="flex-shrink: 0"> -->
		<div v-if='this.type == "edit" || isServiceAvailable()' ref="footer">
			<div class='overflow-auto'>
				<div ref="error-container" class="message-panel-errors" role="alert">

	                <local-error v-bind:inline='[]'></local-error>
	            </div>

				<div v-if='thread == null || (thread != null && thread.closed_at == null && thread.open_for_patient_response == 1)' ref="message-create-container" class="message-create" id="main-content">
					<form role="form">
						<fieldset>
							
						<template>

							<legend v-if="current_question != null" class="message-qa_item" ref="qa_legend" tabindex="0" autofocus>
								<span class="sr-only">Label:</span><strong v-html='formatContent(question_render, true)'></strong>
								<!-- <p v-if='questions[current_question].allow_attachment && !$root.embed'><label class="position-relative btn btn-primary btn-round" for="message-list-file-attach"><span class="icon icon-attachment-inline"></span><span v-text="haveAttachments ? this.$t('translations.attach_another_photo_or_document') : this.$t('translations.attach_photo_or_document')"></span></label></p> -->
							</legend>

							<div class="d-flex align-items-stretch message-response-container" :style="messageResponseContainerHeight">
								<template v-if="show_text_input">
									<div class='d-flex flex-column' style='position: relative;width: 100%;'>
										<!-- <textarea v-on:keyup='isTyping' :class='"new-message-patient p-1" + (internal_message ? " list-message-internal" : "")' v-model="new_message" type="textarea" v-text='new_message'></textarea> -->
										<!-- v-autosize='new_message'  -->
										<label for="patient-message" class="sr-only"><h2 v-html='formatContent(question_render, true)'></h2></label>
										
										<textarea id="patient-message" :class='"flex-grow-1 new-message-patient p-1" + (internal_message ? " list-message-internal" : "")' style='padding-right: 45px !important' v-model="new_message" type="textarea"></textarea>
                                        <p v-if="show_text_input" class='chars-left' aria-live="polite">{{charactersLeft}}</p>
																			
										<template v-if="(!current_question && show_text_input) || (current_question && questions[current_question].allow_attachment)">
											<label v-if="!current_question || questions[current_question].allow_attachment" class="attachment-input-label" for="message-list-file-attach">
												{{ $t('translations.add_attachment_to_message')}}
												<input v-on:change='getAttachment'  id='message-list-file-attach' type="file" accept='image/*,application/pdf,application/octet-stream,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet'>
												<!-- image/*,.docx,.doc,.odt,.xls,.xlsx,.ods,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet -->
											</label>
										</template>
										
										<div class="flex-wrap align-items-end message-attachments" v-show='haveAttachments'>
											<div :key='"image" + index' class="d-flex flex-column mr-1 attachment-item" v-for='(image, index) in attached_images'>
												<div class="m-1">
													<div class="p-1 bg-light m-1 document-upload__container">
														<img v-if='attached_images[index].tn_canvas.toDataURL' class='mt-auto image-preview' :src='attached_images[index].tn_canvas.toDataURL("image/jpeg")'>
													</div>
												</div>
												<button class="btn btn-primary btn-round" v-on:click.prevent='attached_images.splice(index, 1)'>{{ $t('translations.remove')}}</button>
											</div>
											<div :key='"document" + index' class="d-flex flex-column mr-1" v-for='(document, index) in attached_documents'>
												<div class="p-1 bg-light m-1 document-upload__container">
													<img ref='imagePreview' class='mt-auto align-self-center' src='/img/icon-document.svg' width='50' height='50'>
													<p class='align-self-center'>{{document.file_name}}</p>
												</div>
												<button class="mt-auto btn btn-primary btn-round" v-on:click.prevent='attached_documents.splice(index, 1)'>{{ $t('translations.remove')}}</button>
											</div>
										</div>

									</div>
									<!-- <textarea v-on:keyup.enter.exact="processMessage" :class='"new-message-patient p-1" + (internal_message ? " list-message-internal" : "")' v-model="new_message" type="textarea"  v-text='new_message'></textarea> -->
									<!-- <p class='chars-left' aria-live="polite">{{charactersLeft}}</p> -->
								</template>

								
	                            <div v-if='question_buttons.length' class='flex-grow-1'>
	                                <template v-for="(item, key) in question_buttons">
	                                    <button :class='"card-button-sm w-100 mb-2" + (new_message == item.value ? " active" : "")' :key="key" v-on:click.prevent="questionClick(key)" role="button" type="button">
											<div class="card-icon"><img src="/img/egl/icon-placeholder.svg" alt=""></div>
											<h2>{{item.text}}</h2>
											</button>
	                                </template>
	                            </div>
								<!-- <div v-else-if='question_buttons.length' class='flex-grow-1'>
	                                <template v-for="(item, key) in question_buttons">

	                                    <button :class='"btn btn-primary btn-round btn-block btn-wrap" + (new_message == item.value ? " active" : "")' :key="key" v-on:click.prevent="questionClick(key)">
											{{item.text}}
											</button>
	                                </template>
	                            </div> -->
								
								<div class="d-flex flex-row ml-2 message-response-actions" ref="messageResponseActionContainer">
	                                <template v-if="this.thread_id == null">
	                                    <button class="btn btn-warning mr-auto" v-on:click.prevent="closePanel">{{ $t('translations.cancel')}}</button>
										<button v-if='items.data && items.data.length && current_question' class="btn-back mr-2" v-on:click.prevent="goToPreviousQuestion()">{{ $t('translations.back')}}</button>
	                                </template>

									<button class="btn btn-primary" v-on:click.prevent="processMessage" :style="{visibility: show_text_input ? 'visible' : 'hidden'}">
										<!-- <span class="icon icon-send"></span> -->
										<!-- <span v-if='current_question != "q-4" && current_question != "q-10"'>{{$t('translations.next')}}</span> -->
										<span v-if='hasNextQuestion()'>{{ $t('translations.next')}}</span>
										<span v-else>{{ $t('translations.send')}}</span>
									</button>
								</div>
							</div>

							<!-- <p v-if="show_text_input" class='chars-left' aria-live="polite">{{charactersLeft}}</p> -->
							<!-- <button v-if='thread' class="btn btn-warning btn-round" v-on:click.prevent="closeThread">Close</button> -->
						</template>
						</fieldset>
					</form>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		extends: app.base.messageListBase,
		props: [
			'apiRoute',
			'event',
			'model',
			'path',
			'title',
			'type'
		],
		data: function(){
			return {
				errors: [],
                filterFields: {},
				page: 1,
				thread_id: null,
				thread: null,
				user_id: null,
				auxiliary_data: null,
				read_timer: null,
				last_item_created_at: null,
				questions: {},
				current_question: null,
				have_question_answers: false,
				question_render: "",
				show_text_input: true,
				question_buttons: [],
				show_zone_2: false,
				internal_message: false,
				verification_status: {},
				copy_content: "",
				available: false,
				staff: this.$root.lookup.staff,
                events: [],
				edit_index: -1,
				pre_edit_content: "",
                apiBase: '/api/vp1',
                originalData: {
                    "new_message": {name: "Message", value: ""}
                },
				messageResponseContainerHeight: '',
			};
		},
		computed: {
			charactersLeft() {
		        var char = this.new_message.length;
		        var limit = 2048;

				if(this.current_question) {

					if(this.questions[this.current_question].limit) {
						limit = this.questions[this.current_question].limit
					}
					else {
						return "";
					}
				}

				if(char > limit) {
					this.new_message = this.new_message.substr(0, limit);
					char = this.new_message.length;
				}
		    	return (limit - char) + " " + this.$t('translations.characters_remaining');
            },
            editCharactersLeft() {
				var item = this.items.data[this.edit_index];
				if(!item) {
					return "";
				}
				var char = item.message.length;
				var limit = 2048;

				if(item.question_id) {
					if(this.questions["q-" + item.question_id].limit) {
						limit = this.questions["q-" + item.question_id].limit;
					}
					else {
						return "";
					}
				}

				if(char > limit) {
					item.message = item.message.substr(0, limit);
					char = item.message.length;
				}
				return (limit - char) + " " + this.$t('translations.characters_remaining');
			},
			connected() {
				return this.$root.connected;
			},

            filtered_users() {
                var filteredUsers = this.$root.lookup.staff.filter(staff => {
                    //return this.site_id == "" || this.userHasSiteAvailability(staff, this.site_id);
                    return staff.available && (!this.$root.user.provider.site_id || this.userHasSiteAvailability(staff, this.$root.user.provider.site_id));
                });

                filteredUsers.sort((staff1, staff2) => {
                    return this.formatSurname(staff1).localeCompare(this.formatSurname(staff2));
                });
                return filteredUsers;
            },

			// staff() {
			// 	return this.$root.lookup.staff;
			// }

			
			providerName: function() {
				if(this.$root.provider) {
					return this.$root.provider.name;
				}
				return "";
			},
			providerStatus: function() {
				if(!this.isServiceAvailable()) {
					return "(" + this.$t('translations.offline') + ")"
				}
				return "";
			},

    

		},
		watch: {
			route: function (val) {
		 		 this.mounted();
				 //console.log("ROUTE CHANGE!!!!")
            },
    		connected (newState, oldState) {
                // @todo This is causing a race condition, which has become amplified by the path 
                // redirection after login. Basically, the page loads, the getThread kicks off, but then
                // the Echo client connects, and triggers a checkForUpdates before the thread is loaded.
                // This causes the screen to render (because we've got items now) without having the
                // thread object loaded. And that causes lots of thread is undefined errors in the console.
                // Best fix is probably to make the initEcho function return a promise and move all the other
                // init code in to the "then()" function.
				if(newState == true && this.thread_id) {
					this.checkForUpdates();
				}
		    },
			"items.data": {
                handler () {
                    this.loadThumbnails();
                },
                deep: true
            },
		},

		beforeDestroy() {
			this.deinitData();

			//console.log("LEAVING");
		},
        beforeRouteUpdate (to, from, next) {
            this.checkRouteChange(to, from, next);
        },
        beforeRouteLeave(to, from, next) {
            this.checkRouteChange(to, from, next);
        },
		mounted() {
			this.last_item_created_at = null;
			this.errors = [];
			this.initData();
			this.thread = null;
			this.thread_id = null;
            this.internal_message = false;
			this.messageResponseActionHeight();
			
			if(this.type == "edit") {
				this.thread_id = this.$route.params.id;
				this.initEcho();

                //this.getQuestions().then(() => {
                    this.getThread().then(resp => {
                        this.initEncryptStorageLocal(this.$route.params.user_id, this.thread_id);
                        this.loadDraftFromLocalStorage();
                    });
                //});

            }
            /**
             * I think this else statement can be removed from the patient MessageList component.
             * It is only a valid path on the provider MessageList.
             */
			else if(this.$route.path == "/thread-list/thread-create") {
				this.$router.push({path: "/thread-list/thread-create/0"});
			}
            else if(this.type == "create") {
                // You aren't actually allowed to use this route to create new requests any more.
                // All new requests come via the form submissions now.
                // So we can just redirect the user to the intro page
                this.$router.push({name: "profile"});
            }
		},
		updated() {
            // @todo Fix the scrollToEnd so that it doesn't
            // fire when in edit mode, and also doesn't fire
            // possibly when the user has scrolled up the window.
			this.scrollToEnd();
		},
		methods: {
            cancelEditMessage() {
				this.items.data[this.edit_index].message = this.pre_edit_content;
				this.edit_index = -1;
			},

			editMessage(index) {
				this.edit_index = index;
				this.pre_edit_content = this.items.data[index].message;
			},
			saveMessage(index) {

				axios.put(this.apiRoute + '/messages/' + this.items.data[index].id, this.items.data[index]).then((res) => {
					this.edit_index = -1;
					this.setLoading(false);
					this.addNotification({type: "success", content: this.$t('translations.message_updated') });
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "update message");
				});
			},
			deleteMessage(id) {
				axios.delete(this.apiRoute + '/messages/' + id, {}).then((res) => {

				}).catch((error) => {
					this.handleError(error, "delete message");
				});
			},
			initEcho() {
				window.Echo.private('patient.' + this.$root.user.id)
					
					.listen('DeletePatientMessage', (e) => {
                        var deleteIndex = null;

                        //this.addNotification({type: "success", content: this.$t('translations.message_deleted')});
                        //console.log(e);
                        for (var index in this.items.data) {
                            if(e.message_id == this.items.data[index].id) {
                                deleteIndex = index;
                            }
                        }

                        if(deleteIndex !== null) {
                            this.items.data.splice(deleteIndex, 1);
                        }
					})
                    .listen('UpdatePatientThreadAppointment', (e) => {
						for(var index in this.items.data) {
							if(this.items.data[index].appointment_id == e.appointment.id) {
                                console.info("FOUND");
								this.items.data[index].appointment = e.appointment;
							}
						}
					});

                    this.listenWithChunking('patient.' + this.$root.user.id, 'UpdatePatientThread', (e) => {
						if(e.thread && e.thread.id == this.thread.id) {
                            //console.log(JSON.stringify(e, null, 2));
                            //this.addNotification({type: "success", content: 'UpdatePatientThread'});
                            for (var attrname in e.thread) {
                                //console.log(attrname + ": " + this.thread[attrname] + " - " + e.thread[attrname])
                                this.thread[attrname] = e.thread[attrname];
                            }
                            if(this.thread.thread_provider_xref) {
                                this.thread.thread_provider = this.thread.thread_provider_xref.find(obj => {return obj.provider_id == this.$root.user.provider.id});
                            }
                            if(e.thread.deleted_at) {
                                this.closePanel();
                            }
                        }
                    });
                    this.listenWithChunking('patient.' + this.$root.user.id, 'NewPatientMessage', (e) => {
                        if(e.message && e.message.thread_id == this.thread.id) {
                        
                            //console.log(JSON.stringify(e, null, 2));
                            if(e.message.user_id != this.$root.user.id) {
                                this.addNotification({type: "success", content: this.$t('translations.new_message') });
                            }
                            this.checkForUpdates();
                        }
					});
					this.listenWithChunking('patient.' + this.$root.user.id, 'UpdatePatientMessage', (e) => {
                        if(e.message && e.message.thread_id == this.thread.id) {
                            var found = false;
                            for (var index in this.items.data) {
                                if(e.message.id == this.items.data[index].id) {
                                    for (var attrname in e.message) {
                                        //console.log(attrname + ": " + this.thread[attrname] + " - " + e.thread[attrname])
                                        this.items.data[index][attrname] = e.message[attrname];
                                    }
                                    // ONLY EVER DO THIS FOR THE PATIENT
                                    // This is so that if an accidental public message was sent to the patient,
                                    // which was then changed to internal, it would delete from the patient app.
                                    if(this.items.data[index].internal) {
                                        this.items.data.splice(index, 1);
                                    }
                                    found = true;
                                }
                            }
                            if(!found) {
                                this.getResults();
                            }
                        }
					});
                    
			},
			deinitData() {
				if(this.read_timer != null) {
					clearTimeout(this.read_timer);
				}
				this.clearReadActivityMonitor();

				this.userId = null;

				window.Echo.leave('patient.' + this.$root.user.id);
			},
			closePanel() {
				this.$router.push({path: "/profile"});
			},
            /**
             * This needs refactoring. It's a promise. We don't need to pass in a "success" function, just return the promise.
             */
			getQuestions() {
				return axios.get(this.apiRoute + '/questions', {message: this.new_message, thread_id: this.thread_id}).then((res) => {
					//this.setLoading(false);
					this.questions = res.data;
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "create");
                    this.$router.push({"path": "/profile"});
                });
			},
			sendMessage(thread_data = false) {
				this.setLoading(true);

				var data = {
					message: this.new_message,
					thread_id: this.thread_id,
					internal: this.internal_message,
                    auxiliary_data: this.auxiliary_data,
                    attached_images: this.attached_images,
                    attached_documents: this.attached_documents,
				};

				var next_question = null;

				this.errors = [];

				if(this.current_question != null) {
					data.question_id = this.questions[this.current_question].id;

					for(var index in this.questions[this.current_question].branch_rule) {
						//console.log("Testing branch: " + JSON.stringify(this.questions[this.current_question].branch_rule[index], null, 2));
						if(this.questions[this.current_question].branch_rule[index].rule == this.new_message ||
								this.questions[this.current_question].branch_rule[index].rule == null) {
							next_question = "q-" + this.questions[this.current_question].branch_rule[index].to_question_id;
						}
					}
					if(next_question == null) {
						data.end_qa = true;
					}
				}
				console.log("Next question: " + next_question);
				//console.log("Sending message: " + JSON.stringify(data, null, 2));

                return this.postMessage(this.apiRoute + '/messages'
						, data
						, {headers: {'Content-Type': 'multipart/form-data' }},
                        thread_data).then((res) => {
					this.setLoading(false);
					this.new_message = "";
					this.auxiliary_data = "";
					this.internal_message = false;
                    this.attached_images = [];
                    this.attached_documents = [];

					if(this.current_question) {
						if(next_question != null) {
							this.current_question = next_question;

                            this.renderQuestion();

							this.retrieveSavedItem();
						}
						else {
							this.current_question = null;
							this.show_text_input = true;
							this.question_buttons = [];
							this.question_render = "";
							// @todo bit of a hack this. The server sets open_for_patient_response to
							// 0 for us, but we have to wait for the message to be processed which sometimes
							// allows enough time for the patient to send an additional message, which is then
							// rejected.
							res.data.thread.open_for_patient_response = false;
							//this.$parent.getResults();
						}
					}
					
                    // If the message creation returns a message, add it to the items.
					if(typeof this.items.data !== 'undefined' && res.data.message) {
                        console.log("Incoming message from sendMessage")
                        this.addMessages([res.data.message]);
						this.checkForUpdates();
					}
					else {
						this.getResults();
					}
                    return Promise.resolve(res);

				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "create");
                });
			},
			processMessage(event) {
                var thread_data = null;
                if(this.thread_id == null && !this.hasNextQuestion()) {
                    var thread_data = {subject: this.new_message};
                    if(this.$route.params.user_id) {
                        thread_data.user_id = this.$route.params.user_id;
                    }
                    if(this.current_question) {
                        thread_data.question_group_id = this.questions[this.current_question].question_group_id;
                    }
                    if(this.cache.length) {
                        thread_data["suppress_broadcast"] = true;
                    }
                }
				this.setLoading(true);

				this.sendMessage(thread_data).then(res => {
                    if(thread_data) {
                        this.thread_id = res.data.thread.id;
                        this.thread = res.data.thread;
                        this.initEcho();
                        this.checkForUpdates();
                    }
                })

                this.focusLegend();

			},
			renderQuestion() {
					//console.log("current_question: " + this.current_question);
					//console.log("question: " + JSON.stringify(this.questions[this.current_question], null, 2));

					switch(this.questions[this.current_question].question_type_id) {
						case 1:
							this.show_text_input = true;
							this.question_render = this.$t('qa.'+ this.questions[this.current_question].content);
							this.question_buttons = [];
							if(this.questions[this.current_question].is_subject) {
								this.new_message = this.$root.selfHelpSearch.toString();
							}
							break;
						case 2:
							this.show_text_input = false;
							this.question_render = this.$t('qa.'+ this.questions[this.current_question].content);
							this.question_buttons = [];
							for(var index = 0; index < this.questions[this.current_question].question_option.length; index++) {
                                var display = true;
                                if(this.questions[this.current_question].question_option[index].name == 'option_female_clinician'
                                        || this.questions[this.current_question].question_option[index].name == 'option_male_clinician') {
                                    if(!this.$root.provider.clinician_gender_selection_enabled) {
                                        display = false;
                                    }

                                }
                                if(display) {
							//for(var index in this.questions[this.current_question].question_option) {
                                    this.question_buttons.push({
                                        text: this.$t('qa.'+ this.questions[this.current_question].question_option[index].name),
                                        value: this.$t('qa.' + this.questions[this.current_question].question_option[index].value),
                                        action: "next",
                                    });
                                }
							}
							break;
						case 3:
							this.show_text_input = false;
							this.question_render = this.$t('qa.'+ this.questions[this.current_question].content);
							this.question_buttons = [{
								text: this.$t('qa.option_view_online_resources'),
								action: "launch_search",
								value: this.$t('qa.option_val__view_online_resources'),
							},
							{
								text: this.$t('qa.option_continue_to_askmyGP'),
								action: "next",
								value: this.$t('qa.option_val_continue_to_askmyGP'),
							}];

							break;
						case 4:
							this.show_text_input = false;
							this.question_render = this.$t('qa.'+ this.questions[this.current_question].content);
							this.question_buttons = [];
							this.question_buttons.push({
								text: this.$t('qa.option_anyone'),
								action: "next",
								value: this.$t('qa.option_val_anyone'),
							});
							//for(var index = 0; index < this.$root.lookup.staff.length; index++) {
							for(var index in this.filtered_users) {
                                var name = this.formatClinician(this.filtered_users[index]);

                                this.question_buttons.push({
                                    text: name,
                                    action: "next",
                                    value: name,
                                    auxiliary_data: this.filtered_users[index].id,
                                });
							}

							break;
					}
			},
			questionClick(index) {
				console.log("questionClick(): " + index);
				//this.questions[this.current_question].question_type_id
				switch(this.questions[this.current_question].question_type_id) {
					case 2:
					case 4:
						this.new_message = this.question_buttons[index].value;
						if(this.question_buttons[index].auxiliary_data) {
							this.auxiliary_data = this.question_buttons[index].auxiliary_data;
						}
						this.processMessage();
						break;
					case 3:
						switch(this.question_buttons[index].action) {
							case "launch_search":
								alert("Launching search");
								break;
							case "next":
								this.new_message = this.question_buttons[index].value;
								this.processMessage();
								break;
						}
						break;
				}

				this.focusLegend();
			},

			getMessageClass(id) {
				if(this.$root.user) {
					if(this.$root.user.id == id) {
						return "message-mine";
					}
					else {
						return "message-other";
					}
				}
			},
			getMessageAuto(index) {
				if(this.$data.items.data[index].automated) {
					return "message-automated-patient";
				} else {
					return "";
				}
			},
			// @updatehere
			initData() {
				// Not loading any relatedData stuff here any more. Use root lookups instead.
				this.initFilters();
			},
			// @updatehere
			initFilters() {

			},
			// @updatehere
			getThread() {
                this.setLoading(true);

                return axios.get(this.apiRoute + '/threads/' + this.thread_id + (this.$route.params.archive ? "/1" : "")).then((res) => {
					//console.log(res.data);

					this.thread = res.data["thread"];
                    this.getResults();
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/thread-list"});
                });
            },
			addMessages(messages) {
				var found = false;
				var new_id = null;
				for(var new_index in messages) {
					new_id = messages[new_index].id;
					console.log("addMessages(): New message received: " + new_id);
					for(var cur_index in this.items.data) {
						if(this.items.data[cur_index].id == new_id) {
							found = true;
							console.log("addMessages: AVOIDED COLLISION: " + this.items.data[cur_index].id + ":" + new_id);
						}
					}
					if(!found) {
						console.log("addMessages: Adding: " + new_id);
						this.items.data.push(messages[new_index]);
					}
				}
				this.last_item_created_at = this.items.data[this.items.data.length - 1].created_at;
			},
			setReadActivityMonitor() {
				this.clearReadActivityMonitor();
				var moveEvents = ["mousemove", "mousedown", "keypress", "wheel", "touchstart"];
				this.monitoringReadActivity = true;
				for(var index in moveEvents) {
					this.events.push({type: moveEvents[index], listener: this.setRead});
					window.addEventListener(moveEvents[index], this.setRead);
					//window.addEventListener(moveEvents[index], this.setRead, {once: true});
				}
			},
			clearReadActivityMonitor() {
				this.monitoringReadActivity = false;
				while(this.events.length) {
					var event = this.events.pop();
					//console.log("removing: " + event.type + " - " + event.listener);
					window.removeEventListener(event.type, event.listener);
				}
			},
			setRead() {
                if(this.thread && !this.thread.archived && this.thread.id && this.monitoringReadActivity) {
                    this.clearReadActivityMonitor();
                    if(this.read_timer != null) {
                        clearTimeout(this.read_timer);
                    }
                    this.read_timer = setTimeout(this.setReadReal, 1500);
                }
			},
			setReadReal() {
				if(this.thread && !this.thread.archived && this.thread.id) {
					this.clearReadActivityMonitor();
					if(this.items.data && this.items.data.length) {
						axios.put(this.apiRoute + '/threads/setRead/' + this.thread.id + '/' + encodeURI(this.items.data[this.items.data.length - 1].created_at), {}).then((res) => {
							//this.addNotification({type: "success", content: 'Set thread read status to: ' + res.data.read_at});
						}).catch((error) => {
							this.setLoading(false);
							this.handleError(error, "create");
						});
					}
				}
			},
			getResults() {
                if(this.thread_id) {
                    this.setLoading(true);

                    axios.get(this.apiRoute + '/messages/thread/' + this.thread_id + (this.$route.params.archive ? "?archive=1" : "")).then((res) => {

                        this.setLoading(false);
                        this.items = res.data;
                        //console.log("this.items.data.length: " + this.items.data.length);
                        if(this.items.data.length) {
                            this.last_item_created_at = this.items.data[this.items.data.length - 1].created_at;
                        }
                        this.setReadActivityMonitor();
                        this.have_question_answers = false;
                        for(var item in this.items.data) {
                            //console.log("item: " + item);
                            if(this.items.data[item].question_id != null) {
                                this.have_question_answers = true;
                            }
                        }

                        // Re-init any ongoing qa
                        if(this.items.data.length) {
                            var current = this.items.data[this.items.data.length - 1];
                            if(current.question_id) {
                                console.log("Reinitialising QA");
                                // HERE - this background task causes the message list to resize
                                // which delays the update. How to fix?
                                this.getQuestions().then(() => {
                                    var next_question = null;
                                    this.current_question = "q-" + current.question_id;

                                    for(var index in this.questions[this.current_question].branch_rule) {
                                        //console.log("xTesting branch: " + JSON.stringify(this.questions[this.current_question].branch_rule[index], null, 2));
                                        if(this.questions[this.current_question].branch_rule[index].rule == current.message ||
                                                this.questions[this.current_question].branch_rule[index].rule == null) {
                                            next_question = "q-" + this.questions[this.current_question].branch_rule[index].to_question_id;
                                        }
                                    }

                                    if(next_question != null) {
                                        this.current_question = next_question;
                                        this.renderQuestion();
                                    }
                                    else {
                                        this.current_question = null;
                                        this.show_text_input = true;
                                        this.question_buttons = [];
                                        this.question_render = "";
                                        //this.$parent.getResults();
                                    }
                                });
                            }
                        }
                        // Got a thread, but with no messages in it, so we have to start up the QA
                        else {
                            // We should no longer have this, as all threads will have been created via a form
                            // submission. We used to create a new internal QA here.
                        }
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                    });
                }
			},
			checkForUpdates() {
                if(this.thread_id) {
                    console.log("Checking for updates ...");

                    if(!this.last_item_created_at) {
                        console.log("Oops. checkForUpdates() called without a last_item_created_at set.");
                        return this.getResults();
                    }
                    // var search = encodeURIComponent(JSON.stringify([
                    // 	{"field": "thread.id", "value": this.thread_id, "type": "="},
                    // 	{"field": "created_at", "value": this.last_item_created_at, "type": ">"}]));
                    var date = encodeURIComponent(this.last_item_created_at);
                    //axios.get('/api/v1/messages?search=' + search + '&page=' + this.page).then((res) => {
                    return axios.get(this.apiRoute + '/messages/thread/' + this.thread_id + '/' + date + '?page=' + this.page).then((res) => {
                        if(res.data.data.length) {
                            this.addMessages(res.data.data);
                            this.setReadActivityMonitor();
                        }
                    }).catch(error => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                    });
                }
			},
			openCreate(event) {
			},
			scrollToEnd(event) {
				//console.log(event.data);
				if(this.$el) {
					var container = this.$el.querySelector(".list-message");
					if(container) {
						container.scrollTop = container.scrollHeight;
					}
				}
			},
			isTyping() {
				//console.log("Typing");
				//window.Echo.connector.channels['private-patient.' + this.$root.user.id].whisper('hello friends!');
				//window.Echo.private('patient.' + this.$root.user.id,)
				//window.Echo.connector.socket.emit('App\\Events\\UpdateThread', { blah: "1" });
				//window.Echo.connector.socket.emit('UpdatePatientThread', 'private-patient.' + this.$root.user.id, { blah: "1" });
			},
			// showVideo() {
			// 	this.$refs.videoChatModal.show();
			// },
			getUserProxyById() {
				var userProxyID = this.$route.params.user_id;
			},
			getThreadUser() {
				if(this.thread && this.thread.user) {
					return this.formatName(this.thread.user) + " " + this.formatDate(this.thread.user.dob);
				}
				else if(this.$route.name == "threadCreate") {
					if (this.$route.params.user_id) {
                        var caree = this.getCaree(this.$route.params.user_id);
                        if(caree) {
						    return caree.forenames + " " + caree.surname + " " + this.formatDate(caree.dob);
                        }
                        else {
                            this.$router.push({name: "profile"});
                        }
					}
					else {
						return this.formatName(this.$root.user) + " " + this.formatDate(this.$root.user.dob);
					}
				}
            },

			messageResponseActionHeight() {
                if(this.$refs.messageResponseActionContainer) {
                    //console.info(`Setting client height  ${this.$refs.messageResponseActionContainer.clientHeight}px`);
					this.messageResponseContainerHeight = `margin-bottom: ${this.$refs.messageResponseActionContainer.clientHeight}px`;
				}
                // else {
                //     console.info(`Can't find messageResponseActionContainer`);
                // }
			},
            
		}
    }
</script>
